import React, { useState, useContext, useEffect } from 'react'
import { Input, Modal, Form, Checkbox, Row, Col, Button, Select } from 'antd'
import api from '../../services/api'
import SL_Button from '../../components/buttons/Button'
import GeneralContext from '../../context/GeneralContext/GeneralContext'
import { ERegExp } from '../../enums/ERegExp'
import { displayMessage } from "../../helpers/messages";


export default function CreateClient({ handleOnCloseModal }) {
    const [form] = Form.useForm()
    const [states, setStates] = useState()

    const {
        setShowLoading,
        mobile_mode,
    } = useContext(GeneralContext)


    const handleCreateClient = async (values) => {
        setShowLoading(true)

        try {
            await api.client.create(values)
            await handleOnCloseModal(true)
            alert(displayMessage('CREATE_CLIENT_SUCCESS'), 'success', displayMessage('SUCCESS'))
        } finally {
            setShowLoading(false)
        }
    }

    return (
        <Modal
            title={<div className="text-xl font-bold text-fit-red-900">{displayMessage('REGISTER_CLIENT_2')}</div>}
            open={true}
            onCancel={() => handleOnCloseModal(false)}
            centered={true}
            footer={
                <div className='flex justify-end'>
                    <SL_Button className="w-[150px] bg-gray-500 border-transparent" onClick={() => handleOnCloseModal(false)}>{displayMessage('CLOSE')}</SL_Button>

                    <SL_Button className="w-[150px]" onClick={() => form.submit()}>{displayMessage('END_REGISTER')}</SL_Button>
                </div>
            }
            maskClosable={false}
            width={750}
            bodyStyle={{ overflow: 'auto' }}
        >
            <Form
                onFinish={handleCreateClient}
                layout="vertical"
                requiredMark='optional'
                form={form}
            >
                <div className={`flex gap-2 ${mobile_mode ? 'flex-col' : 'flex-row'}`}>
                    <Form.Item
                        label={<span className='text-fit-red-900 font-semibold'>{displayMessage('COMPANY_NAME')}:</span>}
                        name="name"
                        className={`w-full m-0`}
                        rules={[
                            { required: true, message: displayMessage('COMPANY_NAME_MANDATORY') },
                            { pattern: ERegExp.MUST_HAVE_LETTERS.regexp, message: displayMessage('INVALID_INPUT_DATA') },
                            { whitespace: false, message: displayMessage('NO_WHITE_SPACE_WARNING') }
                        ]}
                    >
                        <Input type="text" className='text-fit-red-900' />
                    </Form.Item>

                    <Form.Item
                        label={<span className='text-fit-red-900 font-semibold'>{displayMessage('COMPANY_DOCUMENT')}:</span>}
                        name="cnpj"
                        className={`w-full m-0`}
                        rules={[
                            { required: true, message: displayMessage('COMPANY_DOCUMENT_MANDATORY') },
                            { pattern: ERegExp.ONLY_HAVE_NUMBERS.regexp, message: displayMessage('INVALID_INPUT_DATA') },
                            { whitespace: false, message: displayMessage('NO_WHITE_SPACE_WARNING') }
                        ]}
                    >
                        <Input type="text" className='text-fit-red-900' maxLength={14} />
                    </Form.Item>
                </div>    
            </Form>
        </Modal >
    )
}